import { MarketingTransactionStatus } from './marketing-transaction.types';

const TransationStatus: Record<MarketingTransactionStatus, string> = {
    deposit: 'افزایش موجودی',
    withdraw: 'کسر کارمزد',
    transfer: 'منتقل شده',
};

const getMarketingTransactionStatusLabel = (
    status: MarketingTransactionStatus | undefined,
): string => {
    return status ? TransationStatus[status] : '-';
};

export { TransationStatus, getMarketingTransactionStatusLabel };
